import { combineReducers } from 'redux'

import prices from './prices'
import estimates from './estimates'

export default combineReducers({
  prices,
  estimates
})



// WEBPACK FOOTER //
// ./src/modules/calculations/index.js